import { isDesktop, isMobile, isTablet } from "react-device-detect";

export type DeviceType = "DESKTOP_LAPTOP" | "SMARTPHONE" | "TABLET" | "UNKNOWN";

// react-device-detect's isMobile is true for phones AND tablets, so a tablet
// matches both isMobile and isTablet - that's intentional, not a bug, since
// some backends want both device types included in the filter for such devices.
export const getDeviceTypes = (): DeviceType[] => {
  const types: DeviceType[] = [];

  if (isMobile) types.push("SMARTPHONE");
  if (isTablet) types.push("TABLET");
  if (isDesktop) types.push("DESKTOP_LAPTOP");

  return types.length ? types : ["UNKNOWN"];
};

export const getDeviceTypeQueryParams = (): string =>
  getDeviceTypes()
    .map((type) => `deviceType=${type}`)
    .join("&");
